import Immutable from 'seamless-immutable';
import { AnyAction } from 'redux';

import { PAGE_IN_VIEW } from 'actions/pageView';

const INITIAL_STATE = Immutable({
  page: 'home',
  type: null,
});

export default (state = INITIAL_STATE, action: AnyAction) => {
  switch (action.type) {
    case PAGE_IN_VIEW:
      return state.merge({
        page: action.payload.page,
        type: action.payload.type,
      });
    default:
      return state;
  }
};
